export default __webpack_public_path__ + "static/media/56_Random_Top.2cfc138d.mp4";